import { cn } from "../../../lib/utils";
import { capabilityTypeColor } from "../utils/gatewayUtils";

export default function GatewayCapabilityTypeBadge({
  type,
  className,
}: {
  type: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center px-1.5 py-px rounded text-[10px] font-semibold border leading-4",
        capabilityTypeColor(type),
        className
      )}
    >
      {type}
    </span>
  );
}
